<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <div class="row">
                    <div class="col">
                        <form-date-input v-model="query.start" id="start" label="日期(起)"></form-date-input>
                    </div>
                    <div class="col">
                        <form-date-input v-model="query.end" id="end" label="日期(迄)"></form-date-input>
                    </div>
                </div>
            </div>
            <div class="page-border">
                <div class="row">
                    <div class="col-12 mb-1">
                        <b-button variant="success" @click="file('R1')">外科統計表</b-button>
                    </div>
                    <div class="col-12 mb-1">
                        <b-button variant="success" @click="file('R2')">內科統計表</b-button>
                    </div>
                    <div class="col-12 mb-1">
                        <b-button variant="success" @click="file('R3')">車資與慰問品金額統計表</b-button>
                    </div>
                </div>
            </div>
        </div>
    </page-main>
</template>

<script>
    export default {
        name: 'g3report',
        data: function () {
            return {
                query: { start: '', end: '' }
            }
        },
        created: function () {
            var start = new Date();
            start.setDate(1);
            var end = new Date();
            end.setMonth(end.getMonth() + 1);
            end.setDate(1);
            end.setDate(end.getDate() - 1);

            this.query.start = start;
            this.query.end = end;
        },
        methods: {
            file: function (action) {
                const $a = document.createElement("a");
                $a.href = this.$apiurl + "/api/g3report/" + action + "?start=" + this.getDateStr(this.query.start) + "&end=" + this.getDateStr(this.query.end);
                $a.click();
            },
            getDateStr: function (d) {
                return typeof (d) == "object" ? this.$options.filters.date(d, 'yyyy/mm/dd') : d;
            }
        }
    };
</script>

<style>
</style>